/* Maison MIQU — promotion code copy, wish list, card add-to-cart. */
(function () {
  'use strict';

  var KEY = 'miqu-wishlist';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AED';
    return cur + ' ' + (cents / 100).toLocaleString('en', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function syncUi() {
    var list = read();
    document.querySelectorAll('[data-miqu-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
    document.querySelectorAll('[data-miqu-wishlist-add]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-miqu-wishlist-add')) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-saved', on);
      var label = btn.querySelector('.miqu-wishlist-add__label');
      if (label) label.textContent = label.getAttribute(on ? 'data-label-on' : 'data-label-off');
    });
  }

  function renderDialog() {
    var listEl = document.querySelector('[data-miqu-wishlist-list]');
    var emptyEl = document.querySelector('[data-miqu-wishlist-empty]');
    if (!listEl) return;
    var handles = read();
    listEl.innerHTML = '';
    emptyEl.hidden = handles.length > 0;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    handles.forEach(function (handle) {
      fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.json();
        })
        .then(function (p) {
          var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
          var variant = p.variants.find(function (v) { return v.available; }) || p.variants[0];
          var d = document.getElementById('MiquWishlist').dataset;
          var li = document.createElement('li');
          li.className = 'miqu-wishlist__item';
          li.innerHTML =
            (img ? '<a href="' + esc(p.url) + '" class="miqu-wishlist__media"><img src="' + esc(img) + '" alt="" width="80" height="80" loading="lazy"></a>' : '') +
            '<div class="miqu-wishlist__info"><a href="' + esc(p.url) + '" class="miqu-wishlist__name">' + esc(p.title) + '</a>' +
            '<span class="miqu-wishlist__price">' + money(variant.price) + '</span>' +
            '<div class="miqu-wishlist__actions">' +
            (variant.available ? '<button type="button" class="button button--primary miqu-wishlist__cart" data-variant="' + variant.id + '">' + esc(d.labelCart) + '</button>' : '<span>' + esc(d.labelSoldout) + '</span>') +
            '<button type="button" class="link miqu-wishlist__remove" data-handle="' + esc(handle) + '">' + esc(d.labelRemove) + '</button></div></div>';
          listEl.appendChild(li);
        })
        .catch(function () {
          write(read().filter(function (h) { return h !== handle; }));
          syncUi();
        });
    });
  }

  function addToCart(variantId, btn) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (btn) btn.setAttribute('aria-busy', 'true');
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = root + 'cart';
      })
      .catch(function () {
        if (btn) btn.removeAttribute('aria-busy');
        window.location.href = root + 'cart';
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;

    var copy = t.closest('[data-miqu-copy]');
    if (copy) {
      var code = copy.getAttribute('data-miqu-copy');
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(function () {
          copy.textContent = copy.getAttribute('data-copied') || 'Copied';
          setTimeout(function () { copy.textContent = code; }, 1600);
        });
      }
      return;
    }

    var add = t.closest('[data-miqu-wishlist-add]');
    if (add) {
      e.preventDefault();
      var h = add.getAttribute('data-miqu-wishlist-add');
      var list = read();
      var i = list.indexOf(h);
      if (i === -1) list.push(h);
      else list.splice(i, 1);
      write(list);
      syncUi();
      return;
    }

    var dialog = document.getElementById('MiquWishlist');
    if (t.closest('[data-miqu-wishlist-open]') && dialog) {
      renderDialog();
      if (dialog.showModal) dialog.showModal();
      else dialog.setAttribute('open', '');
      return;
    }
    if (dialog && (t.closest('[data-miqu-wishlist-close]') || t === dialog)) {
      dialog.close ? dialog.close() : dialog.removeAttribute('open');
      return;
    }

    var remove = t.closest('.miqu-wishlist__remove');
    if (remove) {
      write(read().filter(function (x) { return x !== remove.getAttribute('data-handle'); }));
      syncUi();
      renderDialog();
      return;
    }

    var wcart = t.closest('.miqu-wishlist__cart');
    if (wcart) {
      addToCart(wcart.getAttribute('data-variant'), wcart);
    }
  });

  /* Keep the header cart count live: after any cart add/change/update request,
     re-read the cart and redraw the badge (Dawn only renders it on page load). */
  function refreshCartBubble() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var link = document.getElementById('cart-icon-bubble');
        if (!link) return;
        var bubble = link.querySelector('.cart-count-bubble');
        if (cart.item_count > 0) {
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            link.appendChild(bubble);
          }
          bubble.innerHTML =
            (cart.item_count < 100 ? '<span aria-hidden="true">' + cart.item_count + '</span>' : '') +
            '<span class="visually-hidden">' + cart.item_count + ' items in cart</span>';
        } else if (bubble) {
          bubble.remove();
        }
      })
      .catch(function () {});
  }

  var nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
      p.then(function (res) {
        if (res.ok) refreshCartBubble();
      }).catch(function () {});
    }
    return p;
  };

  /* Client reviews (2026-10-21): the homepage "Write a review" button opens a formula picker
     (sections/miqu-reviews.liquid); a product link ending in #write-review opens that product's
     Judge.me review form once the widget has loaded. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var open = t.closest('[data-miqu-reviews-open]');
    if (open) {
      var picker = document.getElementById(open.getAttribute('aria-controls'));
      if (picker) picker.showModal ? picker.showModal() : picker.setAttribute('open', '');
      return;
    }
    var dlg = t.closest('.miqu-reviews__dialog');
    if (dlg && (t.closest('[data-miqu-reviews-close]') || t === dlg)) {
      dlg.close ? dlg.close() : dlg.removeAttribute('open');
    }
  });

  function openReviewForm(tries) {
    var widget = document.getElementById('judgeme_product_reviews');
    if (!widget) return;
    var btn = widget.querySelector('.jm-no-reviews-state .jm-button--primary, .jm-button--primary, .jdgm-write-rev-link');
    if (!btn) {
      if (tries < 40) setTimeout(function () { openReviewForm(tries + 1); }, 250);
      return;
    }
    widget.scrollIntoView({ block: 'start' });
    btn.click();
  }
  if (location.hash === '#write-review') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { openReviewForm(0); });
    } else {
      openReviewForm(0);
    }
  }

  /* Review form links (2026-10-26, client: Ravishan): Judge.me's form says "you agree to our terms and
     conditions and privacy policy" but links both to judge.me. Point them at the store's own policies, in
     the visitor's language. A statement that names Judge.me keeps Judge.me's links. */
  var POLICY_LINKS = 'a[href^="https://judge.me/terms"], a[href^="https://judge.me/privacy"]';
  var policyRoot = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'policies/';

  function fixPolicyLink(a) {
    var statement = a.parentNode;
    if (!statement || /judge\.me/i.test(statement.textContent)) return;
    var page = a.getAttribute('href').indexOf('https://judge.me/terms') === 0 ? 'terms-of-service' : 'privacy-policy';
    a.setAttribute('href', policyRoot + page);
  }

  function fixPolicyLinks(node) {
    if (node.nodeType !== 1) return;
    if (node.matches(POLICY_LINKS)) fixPolicyLink(node);
    node.querySelectorAll(POLICY_LINKS).forEach(fixPolicyLink);
  }

  fixPolicyLinks(document.documentElement);
  new MutationObserver(function (records) {
    records.forEach(function (record) { record.addedNodes.forEach(fixPolicyLinks); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', syncUi);
  if (document.readyState !== 'loading') syncUi();
})();
